export const UseQrQuery = {
  all: '全て',
  without: 'QR利用企業以外',
  only: 'QR利用企業のみ'
} as const;

export type UseQrQueryKey = keyof typeof UseQrQuery;

export const UseQrQueryKeys: readonly UseQrQueryKey[] = ['all', 'without', 'only'];
